<div>
    <span class="bold">
        (
        <span *ngIf="item.status == 'UNKNOWN'">{{ 'Okänd' | translate }}</span>
        <span *ngIf="item.status == 'AWAITING_PRINT_FILE'">{{ 'Tryckfil saknas' | translate }}</span>
        <span *ngIf="item.status == 'PENDING_POSTER'">{{ 'Behandlar produkt' | translate }}</span>
        <span *ngIf="item.status == 'READY'">{{ 'Redo' | translate }}</span>
        )
        {{item.name}} <span *ngIf="item.size"> - {{item.size}}</span>
        <span *ngIf="item.thirdParty && item.thirdParty.texPrint && item.thirdParty.texPrint.clothesDetails">
            &nbsp;|&nbsp;
            <ng-container *ngIf="item.thirdParty.texPrint.clothesDetails.location == 'FRONT'">{{ 'Framsida' | translate }}</ng-container>
            <ng-container *ngIf="item.thirdParty.texPrint.clothesDetails.location == 'BACK'">{{ 'Baksida' | translate }}</ng-container>
        </span>
    </span>
    <div class="ace-color small-text" *ngIf="showSku && item.sku">{{item.sku}}</div>
    <div class="row">
        <div class="col" *ngIf="item.thirdParty && item.thirdParty.pictufy">{{ 'Pictufy-ID:' | translate }}<a href="https://pictufy.com/view/{{item.thirdParty.pictufy.artworkId}}/artwork"
                target="_blank">{{item.thirdParty.pictufy.artworkId}}</a>
        </div>

        <div class="col" *ngIf="globals.currentUser?.role == 'ACE' && item.thirdParty?.bildbyran?.imageId">
            <a [href]="bildbyranOriginalUrl()" download>{{ 'Ladda ner Bildbyrån-original' | translate }}</a>
        </div>

        <div class="col" *ngIf="item.skuTransform">{{ 'SKU-transformering:' | translate }}<br />
            <div class="small-text">{{item.skuTransform.before}} --&gt; {{item.skuTransform.after}}</div>
        </div>


        <div class="col" *ngIf="item.posterId">
            <a [routerLink]="[globals.panelUrl('/posters/' + item.posterId)]" target="_blank">{{ 'Produkt' | translate }}</a>
        </div>
        <div class="col" *ngIf="item.printFileUrl">
            <a href="{{item.printFileUrl}}" target="_blank">{{ 'Tryckfil' | translate }}</a>
        </div>
        <div class="col" *ngIf="item.imageUploadData?.imageUrl">
            <a href="{{item.imageUploadData.imageUrl}}" target="_blank">{{ 'Slutlig bild' | translate }}</a>
        </div>
        <div class="col" *ngIf="item.imageUploadData?.originalImageUrl">
            <a href="{{item.imageUploadData.originalImageUrl}}" target="_blank">{{ 'Originalbild' | translate }}</a>
        </div>

        <div class="col align-right" *ngIf="['PENDING', 'READY'].includes(order.status) && item.status != 'UNKNOWN'">
            <button mat-raised-button class="styled slim" color="primary"
                (click)="makeItemUnknown(order, item)">{{ 'Redigera produkt' | translate }}</button>
        </div>
    </div>

    <!-- AWAITING PRINT FILE -->
    <div class="file-uploader" *ngIf="item.status == 'AWAITING_PRINT_FILE' && order.status == 'PENDING' && !item.isStockItem">
        <file-uploader
            [uploadUrl]="'/poster-orders/' + order._id + '/items/' + item.identifier + '/add-print-file?useAsPrintFile=' + useAsPrintFile"
            [customText]="'Släpp tryckfil här' | translate" (fileUploaded)="printFileAdded($event)">
        </file-uploader>
        <p *ngIf="globals.storeSettings.reviewMode" class="review-mode-hint">
            {{ "(Since you're in review mode, you can just drop a random image here and wait for it to be processed - it usually takes about 10 minutes - before continuing the order simulation)" | translate }}
        </p>
        <div>
            <mat-checkbox [(ngModel)]="useAsPrintFile" color="primary">{{ 'Använd som tryckfil utan att skala om (endast PDF)' | translate }}</mat-checkbox>
        </div>

        <div *ngIf="item.printFileUrl">
            <br />
            <div class="row">
                <div class="col">
                    <a href="{{item.printFileUrl}}" target="_blank">{{ 'Föreslagen tryckfil' | translate }}</a>
                </div>
                <div class="col align-right">
                    <div class="row">
                        <div class="col">
                            <button mat-raised-button class="styled slim" color="primary"
                                (click)="acceptPrintFile(order, item, false)">{{ 'Godkänn denna' | translate }}</button>
                        </div>
                        <div class="col" *ngIf="!item.imageUploadData">
                            <button mat-raised-button class="styled slim" color="primary"
                                (click)="acceptPrintFile(order, item, true)">{{ 'Godkänn permanent' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <!-- UNKNOWN -->
    <div *ngIf="order.status != 'CANCELLED' && item.status == 'UNKNOWN' && itemInfo">
        <div class="row">
            <div class="col-auto">
                <mat-form-field class="">
                    <mat-label>{{ 'Typ' | translate }}</mat-label>
                    <mat-select [(ngModel)]="itemInfo.posterType" (selectionChange)="posterTypeChanged(order, item)">
                        <mat-option [value]="'POSTER'">{{ 'Poster' | translate }}</mat-option>
                        <mat-option [value]="'CANVAS'">{{ 'Canvas' | translate }}</mat-option>
                        <!--  <mat-option [value]="'TSHIRT'">{{ 'T-Shirt' | translate }}</mat-option> -->
                        <mat-option [value]="'CLOTHES'">{{ 'Kläder' | translate }}</mat-option>
                        <mat-option [value]="'STOCK_ITEM'">{{ 'Stock Item' | translate }}</mat-option>
                        <mat-option [value]="'OTHER'">{{ 'Övrigt' | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="itemInfo.posterType == 'CLOTHES'" class="">
                    <mat-label>{{ 'Placering' | translate }}</mat-label>
                    <mat-select [(ngModel)]="itemInfo.location">
                        <mat-option [value]="'FRONT'">{{ 'Front' | translate }}</mat-option>
                        <mat-option [value]="'BACK'">{{ 'Back' | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field class="fullwidth">
                    <mat-label>SKU</mat-label>
                    <mat-select [(ngModel)]="itemInfo.sku" (selectionChange)="skuChanged(order, item)">
                        <mat-option *ngFor="let skuInfo of availableSkuInfoByPosterType[itemInfo.posterType]" [value]="skuInfo.sku">
                            <ng-container *ngIf="productNamesBySKU[skuInfo.sku]">{{productNamesBySKU[skuInfo.sku]}}</ng-container>
                            <ng-container *ngIf="!productNamesBySKU[skuInfo.sku]">{{skuInfo.sku}}</ng-container></mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <button mat-raised-button class="styled slim fullwidth" color="primary" [disabled]="!itemInfo.sku || itemInfo.sku == ''" (click)="addOrderItemInfo(order, item)">{{ 'Spara' | translate }}</button>
            </div>
            <div class="col">
                <button mat-raised-button class="styled slim fullwidth" color="warn" (click)="deleteOrderItem(order, item)">{{ 'Ta bort' | translate }}</button>
            </div>
        </div>
    </div>
</div>